/**
 * Can this browser capture a screen at all?
 *
 * `getDisplayMedia` is the only screen-capture API on the web, and WebKit has
 * never implemented it on iOS — which covers *every* iOS browser, since Chrome,
 * Edge and Firefox there are WebKit skins. It also reads false outside a secure
 * context (`navigator.mediaDevices` is undefined over plain http on a non-local
 * host), which is the right answer: capture genuinely will not work.
 *
 * Browser-only: returns false during SSR, where there is no navigator to ask.
 * Call it from an effect (see `useScreenCaptureSupport`) rather than during
 * render so the server and first client render agree.
 */
export function supportsScreenCapture(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    !!navigator.mediaDevices?.getDisplayMedia
  );
}
